function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.667 2.667c-6.25 0-11.334 4.735-11.334 10.555 0 6.386 7.88 13.65 10.297 15.725.291.25.658.386 1.037.386.38 0 .746-.137 1.037-.386C20.121 26.87 28 19.607 28 13.222c0-5.82-5.084-10.555-11.333-10.555zM17.207 16h-1.08a.532.532 0 00-.382.163.564.564 0 00-.158.392v2.778c0 .295-.113.577-.316.786a1.064 1.064 0 01-.763.325c-.286 0-.56-.117-.763-.325a1.128 1.128 0 01-.316-.786V9.89c0-.442.17-.866.474-1.179a1.596 1.596 0 011.145-.488h2.158c1.002 0 1.963.41 2.672 1.14a3.947 3.947 0 011.106 2.749c0 1.031-.398 2.02-1.106 2.75A3.724 3.724 0 0117.206 16z",
  fill: "#4462FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.206 10.444h-1.079a.532.532 0 00-.382.163.564.564 0 00-.158.392v2.223c0 .147.057.288.158.393a.533.533 0 00.382.162h1.08c.429 0 .84-.175 1.144-.488.304-.313.474-.736.474-1.178 0-.443-.17-.866-.474-1.179a1.596 1.596 0 00-1.145-.488z",
  fill: "#4462FF"
}));